// Written in this round about way for babel-transform-imports
import Switch from 'react-router/es/Switch';

export default Switch;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.4.2.2@react-router-dom/es/Switch.js
// module id = 512
// module chunks = 1